import React from "react";
import Tile from "../../components/Tile/Tile";
import "./GetResearchExperience.css";
import { bookmarkEventBuilder, sendEvent } from "../../utils/event-helpers";
import { useWithSessionData } from "../../hooks/use-with-session-data";
import { toggleResourceBookmark } from "../../features/bookmark/resourceBookmarksSlice";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { ContentfulTileProps } from "../../utils/contentful-helpers";

export interface GetResearchExperienceTilesProps {
  resourceTiles: ContentfulTileProps[];
}

const GetResearchExperienceTiles = ({
  resourceTiles,
}: GetResearchExperienceTilesProps) => {
  const { userId, sessionId } = useWithSessionData();
  const dispatch = useAppDispatch();
  const bookmarks = useAppSelector((state) => state.resourceBookmarks.bookmarkedResources);
  const handleBookmarkResearchExperience = (resourceTile: ContentfulTileProps) => {
    const { id, title, description, thumbnail, url } = resourceTile;
    const isBookmarked = bookmarks.some((bookmark) => bookmark.id === id);
    const eventData = bookmarkEventBuilder(!isBookmarked, userId, sessionId, "ResearchExperienceTile", title, {
      bookmarkedResource: {
        title: title,
        description: JSON.stringify(description),
        resource_id: id,
      },
    });
    sendEvent(eventData);

    dispatch(
      toggleResourceBookmark({ id, title, description, thumbnail, url })
    );
  };

  return (
    <div className="internship-wrapper">
      <div className="get-research-experience-container">
        {resourceTiles.map((tile) => (
          <Tile
            key={tile.id}
            id={tile.id}
            title={tile.title}
            description={tile.description}
            thumbnail={tile.thumbnail}
            url={tile.url}
            isResearchPage={false}
            onBookmark={() => handleBookmarkResearchExperience(tile)}
          />
        ))}
      </div>
    </div>
  );
};

export default GetResearchExperienceTiles;
